export default __webpack_public_path__ + "static/media/Stars1.22b093ca.png";